/**
 * Drop all client auth state so a 401 redirect does not leave stale user/session data
 * (Zustand persist + duplicate localStorage keys used by auth stores).
 */
export function clearClientSession() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('auth-storage');
  } catch {
    /* ignore */
  }
}
